import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { AnnouncementLike } from "../../app/interfaces";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Container from "../../app/components/theme/Container";
import api from "./api";
import { Button, Grid, Tab, Tabs, TextField } from "@mui/material";
import { DatePicker, MemberShipTypeSelect } from "../../app/config/controls";
import TabPanel from "../../app/components/theme/TabPanel";

const initialState: AnnouncementLike = {
  id: "",
  title: "",
  body: "",
  startDate: new Date(),
  endDate: new Date(),
  membershipType: 1,
  views: [],
};

const Announcement = () => {
  const history = useHistory();
  const { id }: { id: string } = useParams();
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [annoucement, setAnnouncement] =
    useState<AnnouncementLike>(initialState);

  const handleTabChange = (event: any, newValue: number) =>
    setTabIndex(newValue);

  const handleBack = () => {
    history.goBack();
  };

  const handleSave = () => {
    if (!annoucement.startDate || !annoucement.endDate) {
      alert("Por favor, complete todos los campos obligatorios.");
      return;
    }
    if (!annoucement.title || !annoucement.body) {
      alert("Por favor, complete todos los campos obligatorios.");
      return;
    }
    let annoucementToSave = { ...annoucement };
    if (!annoucementToSave.id) {
      delete annoucementToSave.id;
    }
    api.create(annoucementToSave).then((response: any) => {
      if (!response.error) {
        history.push("/annoucements");
      }
    });
  };
  const handleChange = (event: any) => {
    setAnnouncement((prev: any) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };
  useEffect(() => {
    if (id) api.load(id).then(setAnnouncement);

    return () => {
      setAnnouncement(initialState);
    };
  }, [id]);

  return (
    <Container
      title={"Anuncio"}
      headerLeftComponent={
        <ChevronLeftIcon onClick={handleBack} style={{ cursor: "pointer" }} />
      }
      headerRightComponent={
        <Button variant="contained" color="primary" onClick={handleSave}>
          Guardar
        </Button>
      }
    >
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        variant="scrollable"
      >
        <Tab tabIndex={0} label="Captura" />
        <Tab tabIndex={1} label="Visualizaciones" />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2} style={{ padding: 16 }}>
            <Grid item xs={12}>
              <div
                style={{
                  backgroundColor: "#7c52dc",
                  padding: "10px",
                  borderRadius: "5px",
                  textAlign: "center",
                  color: "white",
                }}
              >
                <strong>Información Importante:</strong> Solo puede existir un
                anuncio activo por tipo de membresía dentro del rango de fechas
                seleccionadas.
              </div>
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={annoucement.title}
                label="Titulo del anuncio"
                name="title"
                fullWidth
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={annoucement.body}
                label="Contenido del anuncio"
                multiline
                rows={4}
                name="body"
                fullWidth
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ padding: 16 }}>
            <Grid item xs={12}>
              <MemberShipTypeSelect
                value={annoucement.membershipType}
                label="Dirigo a usuarios con membresia:"
                name="membershipType"
                onChange={handleChange}
                viewAll={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ padding: 16 }}>
            <Grid item xs={6}>
              <DatePicker
                label="Se mostrara a partir de:"
                value={annoucement.startDate}
                name="startDate"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <DatePicker
                label="Se mostrara hasta:"
                minDate={annoucement.startDate}
                value={annoucement.endDate}
                name="endDate"
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{
              padding: 16,
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Grid item xs={12} md={6} lg={6}>
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  paddingLeft: "15px",
                  paddingBottom: "15px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <h1 style={{ color: "#7c52dc" }}>{annoucement.title}</h1>
                  <span style={{ color: "gray" }}>{annoucement.body}</span>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ maxWidth: "100px", marginTop: "30px" }}
                  >
                    Aceptar
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <Box sx={{ width: "100%" }}>
          {annoucement?.views?.map((view: any) => (
            <Grid container spacing={2} style={{ padding: 16 }} key={view.id}>
              <Grid item xs={6}>
                <TextField
                  value={view.account.email}
                  label="Email del usuario"
                  name="email"
                  fullWidth
                  disabled={true}
                />
              </Grid>
                <Grid item xs={6}>
                <TextField
                  value={new Date(view.createdAt).toLocaleString()}
                  label="Fecha de visualización"
                  name="createdAt"
                  fullWidth
                  disabled={true}
                />
                </Grid>
            </Grid>
          ))}
        </Box>
      </TabPanel>
    </Container>
  );
};

export default Announcement;
